<template>
  <div>
    <div class="form-group text-left">
      <label for="username-label">New password</label>
      <input
        v-model="password"
        class="form-control"
        placeholder="8 characters min. contains special character,0-9, A-Z, a-z"
        type="password"
        required="true"
        autocomplete="off"
        @keyup.enter="clickedSendVerificationCode()"
      >
      <b-alert
        variant="danger"
        dismissible
        :show="showPasswordError"
        @dismissed="showPasswordError=false"
      >
        Your password must be 8 characters min. abd contains special character, 0-9, A-Z, a-z
      </b-alert>
    </div>
    <div class="form-group text-left">
      <label for="username-label">Confirm password</label>
      <input
        v-model="rePassword"
        class="form-control"
        placeholder="Please re-enter your password"
        type="password"
        required="true"
        autocomplete="off"
        @keyup.enter="clickedSendVerificationCode()"
      >
      <b-alert
        variant="danger"
        dismissible
        :show="showPasswordNotMatchingError"
        @dismissed="showPasswordNotMatchingError=false"
      >
        Your passwords don't match
      </b-alert>
    </div>
  </div>
</template>

<script>

import utils from '../../utils.js'

export default {
	data () {
		return {
			password: '',
			rePassword: '',
			showPasswordError: false,
			showPasswordNotMatchingError: false
		}
	},

	methods: {
		resetShowErrors: function () {
			this.showPasswordError = false
			this.showPasswordNotMatchingError = false
		},

		getPassword: function () {
			return this.password
		},

		validate: function () {
			var areDataValid = true

			if (this.password !== this.rePassword) {
				this.showPasswordNotMatchingError = true

				areDataValid = false
			}
			// Invalid password
			else if (!utils.validatePassword(this.password)) {
				this.showPasswordError = true

				areDataValid = false
			}

			return areDataValid
		},

		clickedSendVerificationCode: function () {

		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
